import Magazine1 from "../../../Assets/img/RTW_2345_websize.jpg"
import Magazine2 from "../../../Assets/img/photobooth1.jpg"
import Magazine3 from "../../../Assets/img/photobooth2.jpg"
import Magazine4 from "../../../Assets/img/photobooth3.jpg"

const MagazineImagesData = [
    {
      imgSrc: Magazine1,
    },
    {
      imgSrc: Magazine2,
    },
    {
      imgSrc: Magazine3,
    },
    {
      imgSrc: Magazine4,
    },
  ];
export default MagazineImagesData;